export const videoActivityKeys = {
  video_activities: () => ['VIDEO_ACTIVITIES'] as const,
};
